import * as React from 'react';
import styled from 'styled-components';
import { createVideoPreviewUrl } from '../../../cloudinary';
import camera from '../../../img/camera.svg';

interface VideoPreviewProps extends React.HTMLProps<HTMLButtonElement> {
    videoId?: string;
    float?: 'right' | 'left';
}

const Preview = styled.img`
    display: block;
    height: 6em;

    &[src$='.svg'] {
        height: 2.2em;
        width: 6em;
        margin: 1em;
    }

    &:not([src$='.svg']) {
        object-fit: cover;
    }
`;

const VideoPreview: React.FC<VideoPreviewProps> = props => <Preview src={getPreview(props)} />;

const getPreview = (props: VideoPreviewProps) => {
    return props.videoId ? createVideoPreviewUrl(props.videoId, 'c_fill,g_auto,h_100,w_160') : camera;
};

export default VideoPreview;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/VideoPreview.tsx